import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const gryd: UnitJsonConfig = {
    id: 'gryd',
    unitName: defineMessage({ message: 'Gryd' }),
    stats: {
        hp: 90,
        stamina: 130,
        speed: 1,
        initiative: 15,
        armor: 55,
        evasion: 0,
        meleeSkill: 95,
        critChance: 5,
        critMult: 1.2,
        armorPenetration: 0.45,
        damageMin: 10,
        damageMax: 12,
    },
    skills: [
        {
        id: 'r_t_sword',
        name: defineMessage({ message: 'Sword Strike' }),
        sort: 10,
        cost: 50,
        range: 1,
        powerMult: 1,
        hitChanceBonus: 10,
        armorPenBonus: 0,
        iconRow: 1,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.55,
        y: 0.7,
    },
    badge: {
        x: 75,
        y: -210,
    },
    unitPortrait: {
        row: 0,
        col: 0,
    },
} satisfies UnitJsonConfig;
